import React from "react";
import { Grid } from "@mui/material";
import { Wifi as InternetIcon } from "@mui/icons-material";
import type { VenueData } from "../../types/venues.types";

interface InternetInfoCardProps {
  venueData: VenueData;
  InfoCard: React.ComponentType<{
    title: string;
    icon: React.ReactNode;
    sx?: object;
    children: React.ReactNode;
  }>;
  InfoRow: React.ComponentType<{
    label: string;
    value: string;
  }>;
}

export const InternetInfoCard: React.FC<InternetInfoCardProps> = ({
  venueData,
  InfoCard,
  InfoRow,
}) => {
  return (
    <InfoCard title="Internet" icon={<InternetIcon />} sx={{ height: "100%" }}>
      <Grid container spacing={2}>
        <InfoRow
          label="Internet Service Provider"
          value={venueData.internet_service_provider || "N/A"}
        />
        <InfoRow label="WiFi Name" value={venueData.wifi_name || "N/A"} />
        <InfoRow
          label="WiFi Password"
          value={venueData.wifi_password || "N/A"}
        />
        <InfoRow
          label="Upload Speed"
          value={
            venueData.internet_upload_speed
              ? `${venueData.internet_upload_speed} Mbps`
              : "N/A"
          }
        />
        <InfoRow
          label="Router Accessibility"
          value={venueData.router_accessibility || "N/A"}
        />
        <InfoRow
          label="Router Distance"
          value={venueData.router_distance_from_livestream || "N/A"}
        />
      </Grid>
    </InfoCard>
  );
};

export default InternetInfoCard;
